import type { HttpError } from '@arcual/lib-app-platform';

export const handleHttpError = (_error: unknown) => {
  const error: HttpError = _error as HttpError;
  console.error('http request error:', error);
  // TODO: integrate with sentry https://app.clickup.com/t/14392315/APL-2953
};
